import { StyleSheet } from '@react-pdf/renderer'
import { PrintHeader, PrintHFlow, PrintText, PrintTitle, PrintVFlow, SpaceLine } from 'components/print'
import { PrintRichText } from 'components/print/components/PrintRichText'
import { formatDayMonthYearHourMinutes } from 'util/date/formatDate'
import { humanizeAge } from 'util/date/humanize-age'
import { CidadaoAtendimento } from 'view/atendimentos/types/CidadaoAtendimento'

import { OrientacaoRowModel, tipoAtendimentoRecord } from '../model-orientacoes'

export interface ImpressaoOrientacoesProps extends OrientacaoRowModel {
  cidadao: CidadaoAtendimento
}

export const ImpressaoOrientacoes = (props: ImpressaoOrientacoesProps) => {
  const { cidadao, atendimentoProfissional, descricao } = props

  const cidadaoNome = cidadao.nomeSocial ? `${cidadao.nomeSocial} (${cidadao.nome})` : cidadao.nome

  const cidadaoNomeBold = `<b>${cidadaoNome}</b>`

  const cpf = cidadao.cpf ? `<b>CPF: </b>${cidadao.cpf}    ` : ''
  const cns = cidadao.cns ? `<b>CNS: </b>${cidadao.cns}` : ''
  const tipoAtendimentoText = atendimentoProfissional?.tipoAtendimento
    ? `<b>${tipoAtendimentoRecord[atendimentoProfissional.tipoAtendimento]}</b>`
    : ''
  const idadeText = humanizeAge(cidadao.dataNascimento)

  return (
    <>
      <PrintTitle title='ORIENTAÇÕES' level={3} />
      <PrintHeader underline styles={classes.header}>
        <PrintVFlow styles={classes.leftColumn}>
          <PrintTitle title='CIDADÃO' level={4} align='left' styles={classes.title} />
        </PrintVFlow>
        <PrintVFlow styles={classes.rightColumn}>
          <PrintTitle title='ATENDIMENTO' level={4} align='left' styles={classes.title} />
        </PrintVFlow>
      </PrintHeader>

      <PrintHFlow styles={classes.hFlow}>
        <PrintVFlow styles={classes.leftColumn}>
          <PrintRichText content={cidadaoNomeBold} />
          {(cidadao.cpf || cidadao.cns) && <PrintRichText content={cpf + cns}></PrintRichText>}
          <PrintText>{idadeText} no dia deste atendimento</PrintText>
        </PrintVFlow>
        <PrintVFlow styles={classes.rightColumn}>
          <PrintRichText content={tipoAtendimentoText} />
          <PrintText>{formatDayMonthYearHourMinutes(atendimentoProfissional?.iniciadoEm)}</PrintText>
          <PrintRichText content='<b>Local de atendimento</b>' />
          <PrintText>{atendimentoProfissional?.atendimento?.localAtendimento?.localAtendimentoExibicao}</PrintText>
        </PrintVFlow>
      </PrintHFlow>

      <SpaceLine />

      <PrintTitle title='ORIENTAÇÕES' level={4} underline align='left' />
      <SpaceLine />
      <PrintRichText content={descricao} />
    </>
  )
}

const classes = StyleSheet.create({
  header: {
    marginTop: 5,
  },
  title: {
    marginBottom: 0,
    paddingHorizontal: 0,
    marginHorizontal: 15,
  },
  hFlow: {
    paddingTop: 5,
  },
  leftColumn: {
    flex: 2,
  },
  rightColumn: {
    flex: 1,
  },
})
